import { TipoPerfilUsuarioEnum } from '../enums';

// #region Import Pages
import ListasConsulta from '../pages/ListasConsulta';
import ListasDetalhe from '../pages/ListasDetalhe';

import Configuracoes from '../pages/Configuracoes';
import DetalheDocumentos from '../pages/DetalheDocumentos';
import DetalheDocumentosInativos from '../pages/DetalheDocumentosInativos';
import ListasMassaInicial from '../pages/ListasMassaInicial';
import ListasRPA from '../pages/ListasRPA';
import RelatorioNestle from '../pages/RelatorioNestle';
import Unauthorized from '../pages/Unauthorized';
import UsuarioDetalhe from '../pages/UsuarioDetalhe';
import UsuarioGestao from '../pages/UsuarioGestao';
import UsuarioNovo from '../pages/UsuarioNovo';

import ConsultaBeneficiariosNestle from '../pages/ConsultaBeneficiariosNestle';
import DetalheBeneficiariosNestle from '../pages/DetalheBeneficiariosNestle';
import EditParametro from '../pages/EditParametro';
import ListaInativo from '../pages/ListaInativo';
import ListaInativoDetalhe from '../pages/ListaInativoDetalhe';
import Parametros from '../pages/Parametros';
import ProcessamentoRelatorio from '../pages/ProcessamentoRelatorio';
import RelatorioBeneficiarios from '../pages/RelatorioBeneficiarios';
import SegundaVia from '../pages/SegundaVia';
import SolicitacaoSegundaVia from '../pages/SolicitacaoSegundaVia';
// #endregion

export const routes = [
  // { id: 1, url: '/error', component: ErrorPage },
  { id: 1, url: '/unauthorized', component: Unauthorized },

  // {
  //     id: 3,
  //     url: '/consulta-beneficiario',
  //     component: ConsultaBeneficiarioPage,
  // },
  // { id: 4, url: '/pagina-inicial', component: PaginaInicial },
  // { id: 2, url: '/login', component: LoginPage, isPrivate: false },
  { id: 5, url: '/lista', component: ListasConsulta, isPrivate: true },
  {
    id: 6,
    url: '/lista/importar-lote',
    component: ListasDetalhe,
    isPrivate: true,
    // roles: [
    //   TipoPerfilUsuarioEnum.returnNameForName.ContratanteAlteracao,
    //   TipoPerfilUsuarioEnum.returnNameForName.ContratanteConsulta,
    // ],
  },
  // { id: 7, url: '/segunda-via', component: SegundaVia },
  // { id: 8, url: '/configuracao', component: Configuracoes },
  // { id: 9, url: '/ajuda', component: AjudaPage },
  // { id: 10, url: '/nova-lista', component: NovaListaPage },
  // { id: 11, url: '/nova-solicitacao', component: NovaSolicitacaoPage },
  {
    id: 12,
    url: '/gestao',
    component: UsuarioGestao,
    isPrivate: true,
    roles: [TipoPerfilUsuarioEnum.returnNameForName.Adm],
  },
  {
    id: 13,
    url: '/gestao/novo-usuario/:perfilNovoUsuario',
    component: UsuarioNovo,
    isPrivate: true,
    roles: [TipoPerfilUsuarioEnum.returnNameForName.Adm],
  },
  {
    id: 14,
    url: '/gestao/detalhe-usuario/:idUsuario',
    component: UsuarioDetalhe,
    isPrivate: true,
    roles: [TipoPerfilUsuarioEnum.returnNameForName.Adm],
  },
  {
    id: 15,
    url: '/configuracoes',
    component: Configuracoes,
    isPrivate: true,
  },
  {
    id: 16,
    url: '/listas-rpa',
    component: ListasRPA,
    isPrivate: true,
    roles: [TipoPerfilUsuarioEnum.returnNameForName.Adm],
  },
  {
    id: 17,
    url: '/listas-massa-inicial',
    component: ListasMassaInicial,
    isPrivate: true,
  },
  {
    id: 18,
    url: '/lista/:idLista/detalhe-documentos',
    component: DetalheDocumentos,
    isPrivate: true,
  },
  {
    id: 19,
    url: '/parametros',
    component: Parametros,
    isPrivate: true,
    roles: [TipoPerfilUsuarioEnum.returnNameForName.Adm],
  },
  {
    id: 20,
    url: '/parametros/editar/:nomeParametrizacao',
    component: EditParametro,
    isPrivate: true,
    roles: [TipoPerfilUsuarioEnum.returnNameForName.Adm],
  },
  {
    id: 21,
    url: '/listainativo/:idLista',
    component: ListaInativo,
    isPrivate: true,
  },
  {
    id: 22,
    url: '/listainativo/:idLista/detalhe',
    component: ListaInativoDetalhe,
    isPrivate: true,
  },
  {
    id: 23,
    url: '/listainativo/:idLista/documentos',
    component: DetalheDocumentosInativos,
    isPrivate: true,
  },
  {
    id: 24,
    url: '/relatorio-nestle',
    component: RelatorioNestle,
  },
  {
    id: 25,
    url: '/beneficiarios-nestle',
    component: ConsultaBeneficiariosNestle,
  },
  {
    id: 26,
    url: '/beneficiarios-nestle/:codigoCartao',
    component: DetalheBeneficiariosNestle,
  },

  /* {
    id: 27,
    url: '/segunda-via',
    component: SegundaVia,
    isPrivate: true,
  },
  {
    id: 28,
    url: '/segunda-via/solicitar',
    component: SolicitacaoSegundaVia,
    isPrivate: true,
  },
  {
    id: 29,
    url: '/segunda-via/:idSolicitacao/editar',
    component: SolicitacaoSegundaVia,
    isPrivate: true,
  },
  {
    id: 30,
    url: '/segunda-via/:idSolicitacao/detalhe',
    component: SolicitacaoSegundaVia,
    isPrivate: true,
  }, */
  {
    id: 31,
    url: '/relatorio-beneficiario',
    component: RelatorioBeneficiarios,
    isPrivate: true,
  },
  {
    id: 31,
    url: '/processamento-relatorio',
    component: ProcessamentoRelatorio,
    isPrivate: true,
  },
];
